<template>
  <v-container>
    <h1>
      <v-icon v-if="!isEdited" class="teams-icon" color="lighten-1" medium
        >mdi-plus</v-icon
      ><v-icon v-else class="teams-icon" color="lighten-1" medium
        >mdi-pencil</v-icon
      >
      <span v-if="!isEdited">New job </span>
      <span v-else>Edit job </span>
    </h1>
    <v-alert v-if="globalServerErrors !== null" dense outlined type="error">
      <p class="mb-0" v-for="globalErr in globalServerErrors" :key="globalErr">
        {{ globalErr[0] }}
      </p>
    </v-alert>
    <formWrapper :validator="$v.form">
      <form @submit.prevent="handleSave" class="form-box">
        <v-row>
          <v-col class="py-2" sm="6" cols="12">
            <form-group name="title" :attribute="`fields.title`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.title"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col class="py-2" cols="12" md="6">
            <form-group
              name="job_category_id"
              attribute="fields.job_category_id"
            >
              <template slot-scope="{ attrs, listeners }">
                <v-select
                  :items="jobCategories"
                  item-text="name"
                  item-value="id"
                  v-bind="attrs"
                  v-on="listeners"
                  v-model="form.job_category_id"
                >
                </v-select>
              </template>
            </form-group>
          </v-col>
          <v-col sm="6" cols="12" class="py-0">
            <section class="increment-label">
              <span>Order</span>
              <number-input
                center
                v-model.number="form.order"
                :min="1"
                :step="1"
                controls
              ></number-input>
            </section>
          </v-col>
          <v-col class="py-2" sm="6" cols="12">
            <form-group name="type" :attribute="`fields.type`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.type"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col cols="12" md="6">
            <v-menu
              ref="menu"
              v-model="menue"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="form.posted_date"
                  label="Posted Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="form.posted_date"
                reactive
                no-title
                show-current
                @input="onDataChange"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col class="py-2" cols="12" md="6">
            <form-group name="is_active" :attribute="`fields.is_active`">
              <template slot-scope="{ attrs, listeners }">
                <v-switch
                  :false-value="0"
                  :true-value="1"
                  v-bind="attrs"
                  v-on="listeners"
                  label="Active Job"
                  v-model.number="form.is_active"
                ></v-switch>
              </template>
            </form-group>
          </v-col>
          <v-col class="py-2" cols="12">
            <form-group name="description" :attribute="`fields.description`">
              <template slot-scope="{ attrs, listeners }">
                <vue-editor
                  v-bind="attrs"
                  v-on="listeners"
                  class="mt-2"
                  v-model="form.description"
                ></vue-editor>
              </template>
            </form-group>
          </v-col>
          <v-col cols="12">
            <v-btn
              block
              rounded
              class="success text-capitalize mt-8"
              large
              type="submit"
              :disabled="$v.form.$invalid"
              ><span>Save</span>
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </formWrapper>
  </v-container>
</template>

<script>
import {
  StoreData,
  ShowData,
  UpdateData,
  IndexData
} from "@/helpers/apiMethods";
import {
  required,
  maxLength,
  minValue,
  minLength,
  numeric
} from "vuelidate/lib/validators";
import { VueEditor } from "vue2-editor";

export default {
  name: "JobCreate",
  components: {
    VueEditor
  },

  data() {
    return {
      menue: false,
      form: {
        title: "",
        job_category_id: "",
        description: "",
        order: 0,
        is_active: 0,
        type: "",
        posted_date: ""
      },
      convvertedDate: "",
      jobCategories: [],
      isEdited: false,
      loadingData: false,
      globalServerErrors: null
    };
  },

  created() {
    this.editCreateBoolean();
    this.handleGetJobCategories();
    this.form.job_category_id = Number(this.$route.query.category);
  },
  methods: {
    onDataChange() {
      this.menue = false;
      this.convvertedDate = this.$moment(this.form.posted_date).format(
        "YYYY-MM-DD HH:mm:ss"
      );
    },
    handleGetJobCategories() {
      IndexData({ reqName: "content/job-categories" }).then(res => {
        const { data } = res.data;
        this.jobCategories = data;
      });
    },
    handleSave() {
      if (!this.isEdited) {
        this.handleCreate();
      } else {
        this.handleEdit();
      }
    },
    editCreateBoolean() {
      if (this.$route.params.id) {
        this.isEdited = true;
      } else {
        this.isEdited = false;
      }
    },
    handleShow(id) {
      ShowData({
        reqName: `content/jobs`,
        id: id
      }).then(res => {
        const { job } = res.data;
        const {
          title,
          description,
          order,
          is_active,
          job_category,
          type,
          posted_date
        } = job;
        this.form = {
          title,
          description,
          order,
          type,
          posted_date: this.$moment(posted_date.date).format("YYYY-MM-DD"),
          is_active: is_active ? 1 : 0,
          job_category_id: job_category.id
        };
      });
    },
    handleCreate() {
      const formData = new FormData();
      this.form.posted_date = this.convvertedDate;
      Object.keys(this.form).forEach(formItem => {
        formData.append(formItem, this.form[formItem]);
      });
      StoreData({
        reqName: `content/jobs`,
        data: formData
      })
        .then(() => {
          this.$router.push(
            `/content/jobs?category=${this.$route.query.category}`
          );
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        });
    },
    handleEdit() {
      const formData = new FormData();
      if (this.convvertedDate !== "") {
        this.form.posted_date = this.convvertedDate;
      }

      Object.keys(this.form).forEach(formKey => {
        formData.append(formKey, this.form[formKey]);
      });
      formData.append("_method", "put");
      UpdateData({
        reqName: `content/jobs`,
        data: formData,
        id: this.$route.params.id
      })
        .then(() => {
          this.isEdited = false;
          this.$router.push(
            `/content/jobs?category=${this.$route.query.category}`
          );

          this.reset();
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    reset() {
      this.$v.form.$reset();
      this.$store.dispatch("ClearServerErrors");
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  },
  watch: {
    $route: {
      handler(route) {
        if (route.name === "editJobs") {
          this.$nextTick(() => {
            this.handleShow(route.params.id);
          });
        }
      },
      immediate: true,
      deep: true
    }
  },
  validations: {
    form: {
      title: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(255)
      },
      description: {
        required,
        minLength: minLength(10)
      },
      type: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(255)
      },
      job_category_id: {
        required
      },
      is_active: {
        required
      },
      order: {
        minValue: minValue(0),
        numeric
      }
    }
  }
};
</script>
